import React, { useContext, useEffect, useState } from "react";
import { ContextProvider } from "../../App";
import { domainUrl } from "../utils/constant";
import axios from "axios";

const useWishListData = () => {
  const [wishListData, setWishListData] = useState([]);
  const { setShowLoader, } = useContext(ContextProvider);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      if (token) {
        try {
          const response = await axios.get(`${domainUrl}/getWishlist`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          // console.log(response);
          setWishListData(response?.data?.wishlist || []);
        } catch (error) {
          // console.log(error.response.data.message);
        } finally {
          setLoading(false);
        }
      } else return;
    };

    fetchData();
  }, [token]);

  return { wishListData, setWishListData, loading, setLoading };
};

export default useWishListData;
